import React from 'react'
import { withTranslation } from 'react-i18next'
import { publicRoute } from '../helpers/publicRoute'

const PageHeadingFragment = ({ t, pageTitle, acronym, researchCenter }) => (
  <div className='uk-text-left' data-uk-grid>
    <div className='uk-width-auto'>
      <div className='uk-card uk-card-default uk-border-rounded'>
        <div className='uk-card-header uk-padding-small'>
          <div className='uk-grid-small' data-uk-grid>
            <div className='uk-width-expand'>
              <h1>{t(pageTitle)}</h1>
              <small>
                <strong>{t(acronym)}</strong> ● {t(researchCenter)}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

const BoardMembersListFragment = ({ t, list }) =>
  list.map(item =>
    typeof item === 'object' ? (
      item.special ? (
        <li key={item.name}>
          {item.affiliation && (
            <div>
              <small>{t(String(item.affiliation))}</small>
            </div>
          )}
          <div>
            <small>{t(String(item.position))}</small> {item.name}
          </div>
          <div>
            {item.title && (
              <span className='uk-label uk-label-success'>
                {t(String(item.title))}
              </span>
            )}
          </div>
        </li>
      ) : (
        <li key={item.name}>
          {item.affiliation && (
            <div>
              <small>{t(String(item.affiliation))}</small>
            </div>
          )}
          <div>
            <small>{t(String(item.position))}</small> {item.name}
          </div>
          <div>
            {item.title && (
              <span className='uk-label uk-label-success'>
                {t(String(item.title))}
              </span>
            )}
          </div>
        </li>
      )
    ) : (
      <li key={item}>{item}</li>
    )
  )

const PublicationListFragment = ({ t, list }) => {
  return (
    <table className='uk-table uk-table-striped uk-table-hover'>
      <thead>
        <tr>
          <th className='uk-table-expand'>{t('publicationList.year')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {list.map(item => (
          <tr key={item.filePath}>
            <td>{item.year}</td>
            <td>
              <span uk-icon='icon: download'></span>
              <a href={publicRoute(item.filePath)}>
                {t('publicationList.download')}
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const PageHeading = withTranslation()(PageHeadingFragment)
const PublicationList = withTranslation()(PublicationListFragment)
const BoardMembersList = withTranslation()(BoardMembersListFragment)
export { PageHeading, BoardMembersList, PublicationList }
